import apiClient from "services/apiClient";

async function addTag(data: any) {
  const url = `/admin/tags`;
  const res = await apiClient.post(url, data);
  return res.data;
}

export default addTag;
